import { COLOR_NEUTRAL, COLOR_NEUTRAL_DARKEST, COLOR_NEUTRAL_MID, COLOR_NEUTRAL_ULTRALIGHT } from '../colors.constants';

export const colorsTabs = {
  colorTabsBackground: COLOR_NEUTRAL_ULTRALIGHT,
  colorTabs: COLOR_NEUTRAL_MID,
  colorTabsActive: COLOR_NEUTRAL_DARKEST,
  colorTabsBorderActive: COLOR_NEUTRAL,
};
